/**
 * @file src/styles/SharedStyles.tsx
 * @exports IconBox
 * @summary Shared icon sizing styles.
 */

import { styled } from "styled-components";
import type { IconBoxProps } from "./types";

export const IconBox = styled.div<IconBoxProps>`
	color: ${({ $color }) => $color || "inherit"};
  height: ${({ $size }) => $size || 20}px;
	/* Prevents it from getting squished in Flexbox */
  min-width: ${({ $size }) => $size || 20}px;
  width: ${({ $size }) => $size || 20}px;
	svg {
		max-height: 100%;
		max-width: 100%;
	}
`;
